// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/portal/js/" + chunkId + "." + __webpack_require__.h().slice(0, 7) + ".js";
};